import { useState, useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import Breadcrumb from '../../components/Breadcrumb';
import NavigationPanelLawyer from '../../components/NavigationPanelLawyer';
import Footer from '../../components/Footer';
import CTAs from '../../components/CTAs';

const InvoiceGeneratorPage = () => {
    const navigate = useNavigate();
  	const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  	
  	const onCTAsContainerClick = useCallback(() => {
		navigate('/loadingscreen');
  	}, [navigate]);
  	
  	const closeLogoutConfirmation = useCallback(() => {
    		setLogoutConfirmationOpen(false);
  	}, []);

	const navItems = [
		{ text: "Dashboard", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/dashboard" },
		{ text: "Legal proceedings & billing", bgColor: "bg-primary-primary-50", textColor: "text-neutrals-neutral-900", hoverBgColor: "bg-primary-primary-50", hoverTextColor: "text-neutrals-neutral-900", path: "" },
		{ text: "Pre-LBA checks", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/prelbacheck" },
		{ text: "Client-debtor interaction", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/cdi1" },
	];

	const breadcrumb = [
		{ label: "", path: "", icon: "assets/home.svg", active: true },
		{ label: "Legal proceedings & billing", path: "/legal_2", icon: "", active: false },
		{ label: "Invoice generator", path: "", icon: "", active: true },
	];
  	
  	return (<>
    		<div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-900 font-open-sans-ff-body-strong">
				{/* Navigation Panel */}
				<NavigationPanelLawyer navItems={navItems}/>

				{/* Main */}
				<div className='w-full absolute top-[128px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border'>
					{/* Breadcrumb */}
					<Breadcrumb breadcrumbs={breadcrumb} textColor="text-primary-primary-500"/>
					<div className='self-stretch flex flex-col items-start justify-start gap-6 text-9xl text-neutrals-neutral-900'>
						<div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
							<div className="flex flex-row items-start justify-start">
								<div className="flex flex-col items-start justify-start gap-1.5">
									<b className="relative">Invoice generator</b>
									<div className="relative text-base text-neutrals-neutral-300">Get your billing information, generate/review invoices.</div>
								</div>
							</div>
							<CTAs
								type="Ghostbtn"
								text="Generate"
								textColor="text-neutrals-neutral-900"
								bgColor="bg-neutrals-neutral-50"
								borderColor="border-neutrals-neutral-100"
								position="relative"
								icon="assets/scan.svg"
								onClick={onCTAsContainerClick}
							/>
						</div>
						<div className='self-stretch flex flex-col items-start justify-start gap-6 text-sm'>
							<div className="self-stretch flex flex-row items-start justify-between gap-0">
								<div className="w-[400px] flex flex-col items-start justify-start gap-2.5">
									<div className="relative font-semibold">Logo</div>
									<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start p-4 gap-2">
										<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
											<img className="w-5 relative h-5" alt="" src="assets/upload_image.svg" />
										</div>
										<div className="flex flex-col items-start justify-start gap-1.5">
											<div className="relative font-semibold">Upload image</div>
											<div className="relative text-base text-neutrals-neutral-300">JPG, JPEG, PNG, less than 5MB</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="flex flex-row items-center justify-start gap-1.5">
										<div className="relative font-semibold">Invoice number</div>
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/help-circle.svg" />
									</div>
									<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-primary-primary-50 border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base text-neutrals-neutral-300">
										<div className="relative">#0123456</div>
									</div>
								</div>
							</div>
							<div className="self-stretch flex flex-row items-start justify-between gap-0">
								<div className="w-[400px] flex flex-col items-start justify-start gap-2.5">
									<div className="relative font-semibold">Your company details</div>
									<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border h-[157px] flex flex-col items-start justify-start p-4 text-base text-neutrals-neutral-300">
										<div className="relative">Enter details over here</div>
									</div>
								</div>
								<div className="w-[400px] flex flex-col items-start justify-start gap-2.5">
									<div className="relative font-semibold">Bill to</div>
									<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border h-[157px] flex flex-col items-start justify-start p-4 text-base text-neutrals-neutral-300">
										<div className="relative">Enter details over here</div>
									</div>
								</div>
							</div>
							<div className="self-stretch flex flex-row items-start justify-between gap-0">
								<div className="w-[400px] flex flex-col items-start justify-start gap-2.5">
									<div className="relative font-semibold">Date issued</div>
									<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-3 text-base text-neutrals-neutral-300">
										<div className="relative">Select date</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="flex flex-row items-center justify-start gap-1.5">
										<div className="relative font-semibold">Billing period</div>
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/help-circle.svg" />
									</div>
									<div className="w-[400px] rounded-3xs bg-primary-primary-50 border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3 text-base text-neutrals-neutral-300">
										<div className="relative">06/01/2024 - 12/01/2024</div>
									</div>
								</div>
							</div>
							<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-between p-6 gap-0">
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="self-stretch flex flex-row items-start justify-start py-2.5 px-3.5">
										<div className="relative font-semibold">Legal services</div>
									</div>
									<div className="flex flex-col items-start justify-start gap-2.5 text-base">
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">Negotiation</div>
										</div>
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">Legal consultation</div>
										</div>
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">Compliance with debt collection laws</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="self-stretch flex flex-row items-start justify-start py-2.5 px-3.5">
										<div className="relative font-semibold">Rate</div>
									</div>
									<div className="flex flex-col items-start justify-start gap-2.5 text-base">
										<div className="w-[82px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£2,000</div>
										</div>
										<div className="w-[82px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£1,000</div>
										</div>
										<div className="w-[82px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] box-border overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£800</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="flex flex-row items-start justify-start py-2.5 px-3.5">
										<div className="relative font-semibold">Hours</div>
									</div>
									<div className="self-stretch flex flex-col items-start justify-start gap-2.5 text-center text-base">
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-center p-3">
											<div className="relative">1</div>
										</div>
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-center p-3">
											<div className="relative">1</div>
										</div>
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-center p-3">
											<div className="relative">2</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-2.5">
									<div className="flex flex-row items-start justify-start py-2.5 px-3.5">
										<div className="relative font-semibold">Amount</div>
									</div>
									<div className="self-stretch flex flex-col items-start justify-start gap-2.5 text-base">
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£2,000</div>
										</div>
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£1,000</div>
										</div>
										<div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex flex-row items-center justify-start p-3">
											<div className="relative">£1,600</div>
										</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-[23px]">
									<div className="w-7 h-[39px]" />
									<div className="flex flex-col items-start justify-start gap-9">
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/cancel.svg" />
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/cancel.svg" />
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/cancel.svg" />
									</div>
								</div>
							</div>
							<div className="self-stretch flex flex-row items-start justify-between gap-0">
								<div className="h-[189px] flex flex-col items-start justify-start gap-2.5">
									<div className="flex flex-row items-center justify-start gap-1.5">
										<div className="relative font-semibold">Notes/payment terms</div>
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/help-circle.svg" />
									</div>
									<div className="w-[400px] flex-1 shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start p-4 text-base text-neutrals-neutral-300">
										<div className="relative">Enter details over here</div>
									</div>
								</div>
								<div className="flex flex-col items-start justify-start gap-6 text-right text-base">
									<div className="w-[294px] flex flex-row items-start justify-between gap-0 text-left">
										<div className="relative font-semibold">Subtotal</div>
										<div className="relative font-semibold text-right">£4,600</div>
									</div>
									<div className="w-[294px] flex flex-row items-center justify-between gap-0">
										<div className="relative font-semibold">Tax</div>
										<div className="relative font-semibold text-left">Free</div>
									</div>
									<div className="w-[294px] flex flex-row items-center justify-between gap-0">
										<div className="relative font-semibold">Total</div>
										<div className="relative font-semibold text-left">£4,600</div>
									</div>
								</div>
							</div>
						</div>
						<Footer/>
					</div>
				</div>
				
    		</div>
    		{isLogoutConfirmationOpen && (
      			<PortalPopup
        				overlayColor="rgba(113, 113, 113, 0.3)"
        				placement="Centered"
        				onOutsideClick={closeLogoutConfirmation}
        				>
        				<LogoutConfirmation onClose={closeLogoutConfirmation} />
      			</PortalPopup>
    		)}</>);
};

export default InvoiceGeneratorPage;